import React, { useState, useEffect } from "react";
import axios from "axios";
import { Table, Container, Spinner } from "react-bootstrap";
import "bootstrap/dist/css/bootstrap.min.css";
import { useNavigate } from "react-router-dom";
import { useTranslation } from 'react-i18next';
import { AiOutlineEdit, AiOutlineDelete } from "react-icons/ai";  // Імпорт іконок
import { Button } from "react-bootstrap";



const FreeNowInfo = () => {
  const { t } = useTranslation();
  const [weekNumber, setWeekNumber] = useState("");
  const [lastName, setLastName] = useState("");
  const [records, setRecords] = useState([]);
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  const fetchAllRecords = async () => {
    setLoading(true);
    setWeekNumber("");
    setLastName("");

    try {
      const response = await axios.get(`/api/freenow/records/all`);
      
      setRecords(
        response.data.sort((a, b) => b.week_number - a.week_number)
      );
    } catch (error) {
      console.error("Error fetching all records:", error);
    }
    setLoading(false);
  };

  useEffect(() => {
    fetchAllRecords();
  }, []);

  const deleteRecord = async (id) => {
    if (!window.confirm(t("deleteQuestion"))) return;

    try {
      await axios.delete(`/api/freenow/records/${id}`);
      console.log(`Deleted record with ID: ${id}`);
      setRecords(records.filter((record) => record.id !== id));
    } catch (error) {
      console.error("Error deleting record:", error);
    }
  };

  return (
    <Container className="mt-4">
      <h2 className="text-center">{t("freenowRecords")}</h2>
      <div className="d-flex justify-content-end mb-3">
        <Button variant="primary" onClick={() => navigate("/add-freenow-info")}>
          ➕ {t("add")} {t("data").toLocaleLowerCase()} FreeNow 
        </Button>
      </div>
      {loading ? (
        <div className="text-center">
          <Spinner animation="border" />
        </div>
      ) : (
        <Table striped bordered hover responsive>
          <thead>
            <tr>
              <th>ID</th>
              <th>{t("name")}</th>
              <th>{t("surname")}</th>
              <th>{t("week")}</th>
              <th>{t("brutto")}</th>
              <th>{t("saldo")}</th>
              <th>{t("cash")}</th>
              <th>{t("bonus")}</th>
              <th>{t("tips")}</th>
              <th>{t("actions")}</th>
            </tr>
          </thead>
          <tbody>
            {records.length > 0 ? (
              records.map((record) => (
                <tr key={record.id}>
                  <td>{record.id}</td>
                  <td>{record.driver_firstName}</td>
                  <td>{record.driver_lastName}</td>
                  <td>{record.week_number}</td>
                  <td>{record.brutto}</td>
                  <td>{record.saldo_freenow}</td>
                  <td>{record.cash}</td>
                  <td>{record.bonus}</td>
                  <td>{record.tips}</td>
                  <td>
                                    <AiOutlineEdit 
                                        style={{ cursor: "pointer", marginRight: "10px", color: "orange" }} 
                                        size={20} 
                                        onClick={() => navigate(`/add-freenow-info/${record.id}`)} 
                                      />
                                      <AiOutlineDelete 
                                        style={{ cursor: "pointer", color: "red" }} 
                                        size={20} 
                                        onClick={() => deleteRecord(record.id)}
                                      />
                  </td>
                  
                </tr>
              ))
            ) : (
              <tr>
                <td colSpan="11" className="text-center">
                  {t("noRecords")}
                </td>
              </tr>
            )}
          </tbody>
        </Table>
      )}
    </Container>
  );
};

export default FreeNowInfo;
